import { C_ACTION } from '../constans';

export const uiChangeProvider = data => ({
  type: C_ACTION.UI_CHANGE_SELECT_PROVIDER,
  data,
});

export const uiChangeWbViewSize = data => ({
  type: C_ACTION.UI_CHANGE_WB_VIEW_SIZE,
  data,
});

export const uiChangeShipmentMode = data => ({
  type: C_ACTION.UI_CHANGE_SHIPMENT_MODE,
  data,
});
export const uiChangeSkladName = data => ({
  type: C_ACTION.UI_CHANGE_SKLADNAME,
  data,
});

export const uiChangeUsersAvatars = data => ({
  type: C_ACTION.UI_USERS_AVATARS,
  data,
});